module.exports = __webpack_public_path__ + "img/CS.ae776107.jpg";